<template>
  <validation-observer ref="replyForm">
    <b-form inline class="d-flex justify-content-between reply-form">
      <b-form-group description="入力すると、他の修了生に返信とコメントが公開されます。">
        <validation-provider name="コメント" rules="max:255" v-slot="validationContext">
          <b-form-input
            id="comment"
            v-model="comment"
            :state="getValidationState(validationContext)"
            type="text"
            class="mr-2"
            style="min-width: 300px;"
            placeholder="コメント(255文字まで)"
            />
          <b-form-invalid-feedback id="input-comment-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </validation-provider>
      </b-form-group>
      <validation-provider name="返信内容" :rules="replyRule" v-slot="validationContext">
        <b-form-select v-model="selectedReplyType" :options="options" class="mr-2 select" style="min-width: 140px;"
          :state="getValidationState(validationContext)"/>
        <b-form-invalid-feedback id="input-reply-feedback">返信内容を選んでください。</b-form-invalid-feedback>
      </validation-provider>
      <app-button
        class="default reply-button"
        style="margin-right: 10px; max-height:calc(1.5em + 0.75rem + 2px)"
        @click="handleClickReply"
        :disabled="isDisabled"
      >
        返信
      </app-button>
    </b-form>
  </validation-observer>
</template>

<script>
import AppButton from '@/components/presentationals/AppButton'

export default {
  name: 'ReplyForm',

  components: {
    AppButton
  },

  props: {
    options: {
      default() {
        return []
      }
    },
    formComment: {
      default() {
        return ''
      }
    },
    replyType: {
      default() {
        return 0
      }
    }
  },

  data() {
    return {
      selectedReplyType: this.replyType,
      comment: this.formComment,
      isDisabled: true
    }
  },
  computed: {
    replyRule() {
      return 'required|numeric|max_value:' + this.options.length + '|min_value:1'
    }
  },

  methods: {
    async updateIsDisabled() {
      if (this.selectedReplyType === '0') {
        this.isDisabled = true
      }
      const result = await this.$refs.replyForm.validate()
      this.isDisabled = !result
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    async handleClickReply() {
      this.$emit('click-reply', [this.selectedReplyType, this.comment])
    }
  },
  mounted() {
    this.isDisabled = this.updateIsDisabled()
  },
  watch: {
    formComment() {
      this.comment = this.formComment
    },
    selectedReplyType() {
      this.isDisabled = this.updateIsDisabled()
    },
    comment() {
      this.isDisabled = this.updateIsDisabled()
    }
  }
}
</script>

<style scoped>
.select:hover{
  cursor: pointer;
}

.reply-form {
  align-items: flex-start;
}
.reply-button:not(:disabled):hover {
  cursor: pointer;
  opacity: 0.9;
}
</style>
